import * as React from 'react'
import { PlusOutlined, SaveOutlined } from '@ant-design/icons'
import { Button, Form, PageHeader } from 'antd'
import { RouteComponentProps, withRouter } from 'react-router'

import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import container from '../../wires/Bootstrapper'

import { IUtenteService } from '../../services/UtenteService'
import { UtenteViewModel } from '../../models/UtenteModels'
import { FormUtente } from './edit/FormUtente'
import { ListClienteRole } from './edit/ListClienteRole'
import { ModalClienteRole } from './edit/ModalClienteRole'
import { UtenteParams } from './UtenteParams'


interface UtenteEditComponentProps {
    backPath: string
    currentPath: (id: string) => string
    clienteId?: string
}

export class UtenteEditComponentState extends UtenteViewModel {
    ModalVisible: boolean = false
}

export class UtenteEditComponentComp extends React.Component<RouteComponentProps<UtenteParams> & UtenteEditComponentProps, UtenteEditComponentState> {

    service: IUtenteService

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.UTENTE_SERVICE)
        this.state = new UtenteEditComponentState()
    }

    componentDidMount() {
        this.loadPage()
    }

    loadPage = async () => {
        let resp = await this.loadData()
        if (resp.IsValid == true)
            this.setState(resp)
    }

    loadData = async () => {
        let id = this.props.match.params.id
        return await this.service.Get(id)
    }

    onSaveClick = async () => {
        let resp = await this.service.Save(this.state)
        if (resp.IsValid == true && this.props.match.params.id == null) {
            const path = this.props.currentPath(resp.Id)
            this.props.history.push(path)
        }
    }

    toggleModal = (visible: boolean) => {
        this.setState({ ModalVisible: visible })
    }

    renderWithId = () => {
        if (this.props.match.params.id == null) return

        return (
            <>
                <PageHeader title="Ruoli e clienti" extra={[
                    <Button type="primary" key="add" icon={<PlusOutlined />} onClick={() => this.toggleModal(true)}>Aggiungi ruolo</Button>
                ]}>
                    <ListClienteRole list={this.state.RuoloClientiList} />
                </PageHeader>

                <ModalClienteRole
                    clienteId={this.props.clienteId}
                    visible={this.state.ModalVisible}
                    closeModal={() => this.toggleModal(false)}
                    do={() => this.loadPage()}
                />
            </>
        )
    }

    onBack = () => {
        this.props.history.replace(this.props.backPath)
    }

    render() {
        return (
            <>
                <PageHeader title="Utente" onBack={() => this.onBack()} extra={[
                    <Button type="primary" key="save" icon={<SaveOutlined />} onClick={() => this.onSaveClick()}>Salva</Button>
                ]}>
                    <Form>
                        <FormUtente
                            nominativo={this.state.Nominativo} onNominativoChange={e => this.setState({ Nominativo: e })}
                            username={this.state.Username} onUsernameChange={e => this.setState({ Username: e })}
                            email={this.state.Email} onEmailChange={e => this.setState({ Email: e })} />
                        <span style={{color:"white"}}>{this.state.Password}</span>
                    </Form>
                </PageHeader>
                {this.renderWithId()}
            </>
        )
    }
}

export const UtenteEditComponent = withRouter(UtenteEditComponentComp)